<template>
  <span class="pi-spark">
    <svg v-if="!geometry.empty" class="pi-spark__svg" :width="width" :height="height"
         :viewBox="'0 0 ' + width + ' ' + height" role="img" :aria-label="summary" focusable="false">
      <title>{{ summary }}</title>
      <path :d="geometry.area" class="pi-spark__area"/>
      <path :d="geometry.path" class="pi-spark__line" fill="none"/>
      <circle v-if="geometry.last" :cx="geometry.last.x" :cy="geometry.last.y" r="2.5" class="pi-spark__dot"/>
    </svg>
    <span v-else class="pi-spark__empty">sem tendência</span>
  </span>
</template>

<script>
import { sparklineGeometry } from "./piScale.js";
import { formatDate, formatValue } from "./piFormat.js";

export default {
  name: "pi-sparkline",
  props: {
    points: { type: Array, default: () => [] },
    unit: { type: String, default: "count" },
    label: { type: String, default: "" },
    width: { type: Number, default: 120 },
    height: { type: Number, default: 32 },
  },
  computed: {
    geometry() {
      return sparklineGeometry(this.points, this.width, this.height);
    },
    summary() {
      const list = (this.points || []).filter((point) => point && typeof point.value === "number");
      if (!list.length) return "Sem tendência";
      const first = list[0];
      const last = list[list.length - 1];
      const name = this.label ? this.label + ": " : "";
      return name + "tendência de " + formatDate(first.date) + " a " + formatDate(last.date) +
        ", de " + formatValue(first.value, this.unit) + " para " + formatValue(last.value, this.unit) +
        " (mínimo " + formatValue(this.geometry.min, this.unit) + ", máximo " + formatValue(this.geometry.max, this.unit) + ")";
    },
  },
};
</script>

<style scoped>
.pi-spark {
  display: inline-block;
  line-height: 0;
}

.pi-spark__svg {
  display: block;
  overflow: visible;
}

.pi-spark__area {
  fill: #1b59f8;
  fill-opacity: 0.1;
}

.pi-spark__line {
  stroke: #1b59f8;
  stroke-width: 1.5;
  stroke-linejoin: round;
}

.pi-spark__dot {
  fill: #1b59f8;
}

.pi-spark__empty {
  display: inline-block;
  font-size: 11px;
  line-height: 16px;
  color: #6b7280;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/pi/piSparkline.vue